import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const SIZE_MAP = { sm: 28, md: 40, lg: 56 };

/**
 * 카드/차트 등 좁은 영역용 (기존 #MiniLoading 위치 스타일 유지)
 */
function MiniLoading({ show, size = "md" }) {
  const px = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <>
      {show && (
        <div id="MiniLoading">
          <CircularProgress style={{ color: "#4e7ce9" }} size={px} />
        </div>
      )}
    </>
  );
}

export default React.memo(MiniLoading);
